import ReporteIva from '../componentes/ReporteIva.vue'


const routes = [
	...route('/reporte-iva', ReporteIva, {Auth: true}),
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes